import { render, staticRenderFns } from "./cooperation-visa-index.vue?vue&type=template&id=4db6ff28&scoped=true&"
import script from "./cooperation-visa-index.vue?vue&type=script&lang=js&"
export * from "./cooperation-visa-index.vue?vue&type=script&lang=js&"
import style0 from "./cooperation-visa-index.vue?vue&type=style&index=0&id=4db6ff28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db6ff28",
  null
  
)

export default component.exports